import React from 'react'
import { CircularProgress, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import { ClassesType } from '../types'

const useStyles = makeStyles(
  theme => ({
    loaderContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      backgroundColor: theme.colors.contentBackground,
      zIndex: theme.utils.modifyZIndex(theme.zIndex.searchShadow, 'above', 2),
    },
    preloaderText: {
      marginTop: theme.spacing(1),
      fontWeight: 500,
    },
    transparent: {
      backgroundColor: 'transparent',
    },
    halfTransparent: {
      opacity: 0.5,
    },
  }),
  { name: 'CircularProgressOverlay' },
)

interface CircularProgressOverlayProps {
  readonly className?: string
  readonly classes?: ClassesType<typeof useStyles>
  readonly halfTransparent?: boolean
  readonly open?: boolean
  readonly preloaderText?: string
  readonly progressSize?: number
  readonly transparent?: boolean
}

const CircularProgressOverlay = ({
  className,
  classes: classesProp,
  preloaderText,
  progressSize = 32,
  transparent = false,
  halfTransparent = false,
  open,
}: CircularProgressOverlayProps) => {
  const classes = useStyles({ classes: classesProp })

  if (!open) {
    return null
  }

  return (
    <Grid
      container
      alignItems="center"
      className={classNames(className, classes.loaderContainer, {
        [classes.transparent]: transparent,
        [classes.halfTransparent]: halfTransparent,
      })}
      direction="column"
      justifyContent="center"
      wrap="nowrap"
    >
      <CircularProgress size={progressSize} />
      {preloaderText && (
        <Typography className={classes.preloaderText}>
          {preloaderText}
        </Typography>
      )}
    </Grid>
  )
}

export default CircularProgressOverlay
